export const PRODUCTION_DISPLAY_ROLE = "ekran_produkcji";

export const isProductionDisplayOnlyUser = (userType) =>
  userType === PRODUCTION_DISPLAY_ROLE;

export const getAuthenticatedLandingRoute = (userType) =>
  isProductionDisplayOnlyUser(userType)
    ? { name: "ProductionDisplayBoard" }
    : "/home";
